import { media, spacing } from '@gyym/ui'
import styled from 'styled-components'

interface BreadcrumbsContainerProps {
  pcOnly?: boolean
  bleed?: boolean
}

export const BreadcrumbsContainer = styled.div<BreadcrumbsContainerProps>`
  width: 100%;
  display: ${({ pcOnly }) => (pcOnly ? 'none' : 'block')};
  padding: ${spacing(4, 0, 2)};
  margin: ${({ bleed }) => (bleed ? spacing(0, -4) : 0)};

  ${media.pc} {
    margin: ${({ bleed }) => (bleed ? spacing(0, -10) : 0)};
    display: block;
  }
`
